<div id="top-of-page"></div>
<app-back-header
  [headerText]="'Torna alla lista Prodotti'"
  (backAction)="onCancel()"
  class="sticky-top"
>
</app-back-header>

<!-- I blocchi entrano uno dopo l'altro dall'alto (.izy-enter + ritardo per
     posizione, come in dashboard, dettaglio fattura e dettaglio cliente). -->
<div
  class="d-flex justify-content-between align-items-start mt-3 ms-1 mb-3 w-100 izy-enter"
  style="animation-delay: 0ms">
  <div>
    <h3 class="m-0">Modifica prodotto</h3>
    <p class="m-0 text-muted">Clicca sulla scheda per espanderne il contenuto</p>
  </div>
</div>

<p class="ms-1 small text-muted izy-enter" style="animation-delay: 60ms">
  I campi contrassegnati da * sono obbligatori.
</p>

<form [formGroup]="productForm" (ngSubmit)="onSubmit()">
  <mat-expansion-panel
    class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 120ms"
    [expanded]="true"
    #panel
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        Prodotto / Servizio
      </mat-panel-title>
      <mat-panel-description>
        {{ productForm.get('name')?.value ? productForm.get('name')?.value : 'Prodotto' }}
        <span class="panel-state">{{ panel.expanded ? 'Chiudi' : 'Apri' }}</span>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="row">
      <mat-form-field appearance="outline" class="w-sm-50">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" required />
        <mat-error *ngIf="productForm.get('name')?.invalid">
          <span *ngIf="productForm.get('name')?.errors?.['required']">
            Il nome è obbligatorio
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Tipo</mat-label>
        <mat-select
          formControlName="type"
          class="izy-select-trigger"
          panelClass="izy-select-panel izy-select-panel--form"
        >
          <mat-option *ngFor="let type of typeOptions" [value]="type.code">
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Unità di misura</mat-label>
        <input matInput formControlName="units" />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline" class="w-sm-50">
        <mat-label>Descrizione</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="6"
          formControlName="description"
        ></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Prezzo unitario</mat-label>
        <input matInput formControlName="unit_price" type="number" required />
        <mat-error *ngIf="productForm.get('unit_price')?.invalid">
          <span *ngIf="productForm.get('unit_price')?.errors?.['required']">
            Il prezzo unitario è obbligatorio
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Percentuale IVA</mat-label>
        <input matInput formControlName="iva_percentage" />
      </mat-form-field>
    </div>

    <!-- L'unica azione della schermata: petrol pieno bordato nero. Il click e'
         gestito dal (ngSubmit) del form, quindi il pulsante e' solo type submit
         (con anche un (click)="onSubmit()" il salvataggio partirebbe due volte).
         .hidden-mobile non impone un display, quindi l'allineamento a destra
         passa da text-end: il pulsante e' inline-flex. -->
    <div class="text-end hidden-mobile">
      <button
        matButton="filled"
        type="submit"
        [disabled]="!productForm.valid"
        class="mt-2 izy-button-primary custom-button-border"
      >
        <mat-icon>save</mat-icon>
        Salva modifiche
      </button>
    </div>
    <!-- mobile version -->
    <div class="visible-mobile">
      <button
        matButton="filled"
        type="submit"
        [disabled]="!productForm.valid"
        class="w-100 mt-2 izy-button-primary custom-button-border"
      >
        <mat-icon>save</mat-icon>
        Salva modifiche
      </button>
    </div>
  </mat-expansion-panel>
</form>

<div class="pt-3 mb-3"></div>

<div *ngIf="isLoading" class="loading-overlay">
  <mat-spinner diameter="40"></mat-spinner>
  <p>Caricamento in corso...</p>
</div>
